import React, { Component, Fragment, useContext, useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import { SessionContext } from '../context/SessionProvider';
import BiToast from './uic/layout/BiToast';

const NavMenu = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const { sessionReady, sessionData, toastError, toastOK, toastData, loading, setHelpMainKey } = useContext(SessionContext)


    return (
        <header>
             <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white  border-bottom box-shadow mb-3" container light>
                <NavbarBrand tag={Link} to="/">
                    <div style={{ display: 'flex', alignItems: "center" }}  >
                        <img src="logo.jpg" height="60" />
                        <span style={{ marginLeft: "20px", fontSize: "35px", color: "#32b458"}} >Portal za stranke</span>

                        {loading &&
                            <div className="spinner-border text-primary" role="status" style={{
                                position: "relative",
                                float: "right",
                                marginBottom: "0px",
                                marginLeft:"20px",
                                top: "4px",
                                height: "26px",
                                width: "26px",
                                borderWidth: "0.1em",
                                borderColor: "rgb(50, 180, 88)",
                                borderRightColor: "white"
                            }}>
                            </div>
                        }

                    </div>
                </NavbarBrand>
                <NavbarToggler onClick={() => setCollapsed(!collapsed)} className="mr-2" />
                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
                    <ul className="navbar-nav flex-grow">
                        {sessionData &&
                            <Fragment>
                                {sessionData.user.admin &&
                                    <Fragment>
                                        <NavItem>
                                            <NavLink tag={Link} className="text-dark" to="/domovAdmin"><i className="fas fa-house-user" ></i> Osnovni podatki</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} className="text-dark" to="/obrazciAdmin"><i className="fas fa-file-circle-check" ></i> Obrazci</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} className="text-dark" to="/prijava"><i className="fas fa-file-pen" ></i>Vpis stranke</NavLink>
                                        </NavItem>
                                    </Fragment>
                                }

                                {!sessionData.user.admin &&
                                    <Fragment>
                                        <NavItem>
                                            <NavLink tag={Link} className="text-dark" to="/domov"><i className="fas fa-house-user" ></i> Osnovni podatki</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} className="text-dark" to="/obrazciStranka"><i className="fas fa-file-pen" ></i>Obrazci</NavLink>
                                        </NavItem>
                                        {/*<NavItem>*/}
                                        {/*    <NavLink tag={Link} className="text-dark" to="/certifikatiStranka"><i className="fas fa-certificate" ></i>Certifikati</NavLink>*/}
                                        {/*</NavItem>*/}
                                    </Fragment>
                                }


                                <BiToast toastData={toastData} ></BiToast>
                               
                            </Fragment>
                        }
                        <li style={{ padding: "15px" }} ></li>
                        <LoginMenu>
                        </LoginMenu>
                    </ul>
                </Collapse>
            </Navbar>


        </header>
    );
}
export default NavMenu;
